import { createContext, useContext, ReactNode } from 'react';
import { TakerMarket } from '../../data/useTakerMarkets';
import { FilterState, FilterSource, useOfferActivityFilterLogic } from './useOfferActivityFilterLogic';

interface OfferActivityFilterContextValue {
  filters: FilterState;
  takerMarkets: TakerMarket[];
  filteredTakerMarkets: TakerMarket[];
  availableCustomers: Array<{ uuid: string; name: string }>;
  totalCustomerCount: number;
  totalDivisionCount: number;
  filteredCustomerCount: number;
  filteredDivisionCount: number;
  setMakerOrganization: (uuid: string) => void;
  setParticipation: (participation: string, source?: FilterSource) => void;
  setAccepted: (accepted: string, source?: FilterSource) => void;
  clearFilters: () => void;
}

const OfferActivityFilterContext = createContext<OfferActivityFilterContextValue | undefined>(undefined);

export const OfferActivityFilterProvider = ({
  children,
  takerMarkets,
  initialMakerOrganizationUuid = '',
}: {
  children: ReactNode;
  takerMarkets: TakerMarket[];
  initialMakerOrganizationUuid?: string;
}) => {
  const value = useOfferActivityFilterLogic(takerMarkets, initialMakerOrganizationUuid);

  return <OfferActivityFilterContext.Provider value={value}>{children}</OfferActivityFilterContext.Provider>;
};

export const useOfferActivityFilters = () => {
  const context = useContext(OfferActivityFilterContext);

  if (!context) {
    throw new Error('useOfferActivityFilters must be used within OfferActivityFilterProvider');
  }

  return context;
};
